import type { ReactNode } from 'react'

type OrderFormLayoutProps = {
  children: ReactNode
  /** Omit (or pass null) to let the step use the full width — e.g. the radiology
   *  facility step, where the list + map need the room more than the cart does. */
  cart?: ReactNode
  header?: ReactNode
}

export const OrderFormLayout = ({ children, cart, header }: OrderFormLayoutProps) => (
  <div className="p-4">
    {header && <div className="max-w-5xl">{header}</div>}
    <div className="flex gap-6">
      <div className={`min-w-0 flex-1 ${cart ? 'max-w-5xl' : ''}`}>{children}</div>
      {cart && (
        <div className="sticky top-20 hidden max-h-[calc(100vh-6rem)] w-80 flex-shrink-0 self-start overflow-auto lg:block">
          {cart}
        </div>
      )}
    </div>
  </div>
)
